function openBillDetailsInNewTab(billId: string | number | undefined | null) {
  if (!billId) return;
  const url = `/bill-details/${billId}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export default openBillDetailsInNewTab;
